export default "__VITE_ASSET__DfqvpauN__"